import React from 'react';
import { Link } from 'react-router-dom';
import { formatMoney } from '../../shared/formatMoney';

export default function PendingBalances({ items = [], loading }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm">
      <div className="flex justify-between items-center px-5 pt-4 pb-2 border-b-2 border-brand-primary">
        <h3 className="text-xs font-extrabold uppercase tracking-wider text-brand-secondary">
          Drivers w/ Pending Balances
        </h3>
        <Link to="/drivers" className="text-xs font-semibold text-brand-primary">
          View all →
        </Link>
      </div>
      <div className="px-5 py-3 space-y-2">
        {loading ? (
          <p className="text-xs text-gray-400 py-2">Loading...</p>
        ) : items.length === 0 ? (
          <p className="text-xs text-gray-400 py-2">All drivers are settled.</p>
        ) : (
          items.map((driver) => (
            <div key={driver.id_no} className="flex items-center justify-between py-1 border-b border-gray-50 last:border-b-0">
              <Link to={`/drivers/${driver.id_no}`} className="text-xs font-semibold text-brand-primary hover:underline truncate">{driver.name}</Link>
              <span className="text-xs font-bold text-brand-secondary ml-2 shrink-0 tabular-nums">
                {formatMoney(driver.bal)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
